(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/hooks/use-customer-properties.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/hooks/use-customer-properties.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  communicationSettingsService
} = svs.myProfile.react.pages.communicationSettings.communicationSettings;

const useCustomerProperties = (setPlayerPropertiesData, setShouldShowApiError) => {
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useEffect(() => {
    const getCustomerDataEmailMobile = async () => {
      try {
        svs.myProfile.logger.debug('Fetch Customers Properties data from backend...');
        const {
          playerProperties
        } = await communicationSettingsService.getCustomersPropertiesAsync();
        setPlayerPropertiesData(playerProperties);
        svs.myProfile.logger.debug('Fetch Customers Properties data from backend... success');
      } catch (error) {
        svs.myProfile.logger.error('CommunicationSettings: catch: Fetch Customers Properties error...', error);
        setShouldShowApiError(true);
      }
    };
    if (isPlayerLoggedIn) {
      getCustomerDataEmailMobile();
    }
  }, []);
};
useCustomerProperties.propTypes = {
  setPlayerPropertiesData: PropTypes.func.isRequired,
  setShouldShowApiError: PropTypes.func.isRequired
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.hooks.useCustomerProperties = useCustomerProperties;

 })(window);